import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import moment from "moment";
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert, getConfig } from "utils";

export const staffAttendanceList = createAsyncThunk('staffAttendance/list', async ({ pageable: data, navigate }) => {
    try {
        const res = await axios({
            method: 'GET',
            url: getConfig.API_URL + `attendance`,
            params: {
                pageSize: data?.pageSize,
                pageNo: data?.currentPage,
                search: data?.search,
                type_id: data?.type_id,
                sub_type_id: data?.sub_type_id,
                in_time: data?.date
                    ? (moment(data.date, 'YYYY-MM-DD', true).isValid()
                        ? data.date
                        : moment(data.date, 'DD/MM/YYYY').format('YYYY-MM-DD'))
                    : undefined,
                fDate: data?.fDate || undefined,
                tDate: data?.tDate || undefined,
                service_provider_id: data?.service_provider_id,
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const staffAttendanceCalendar = createAsyncThunk('staffAttendance/calendar', async ({ pageable: data, navigate }) => {
    try {
        const res = await axios({
            method: 'GET',
            url: getConfig.API_URL + `staff_calendar`,
            params: {
                service_provider_id: data?.service_provider_id,
                unit_id: data?.unit_id,
                month: data?.month,
                year: data?.year,
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const markStaffAttendance = createAsyncThunk('staffAttendance/mark', async ({ attendance_id, attendance_status }) => {
    try {
        const res = await axios({
            method: 'PUT',
            url: getConfig.API_URL + `mark_attendance`,
            data: {
                attendance_id,
                attendance_status,
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const staffAttendanceDetails = createAsyncThunk('staffAttendance/details', async ({ id, navigate }) => {
    try {
        const res = await axios({
            method: 'GET',
            url: getConfig.API_URL + `my_attendance/${id}`,
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
})

const staffAttendance = createSlice({
    name: 'staffAttendance',
    initialState: {
        list: [],
        calendarData: null,
        details: null,
        loading: false,
        calendarLoading: false,
    },
    reducers: {
        resetCalendarData: (state) => {
            state.calendarData = null
        },
    },
    extraReducers: (builder) => {
        builder.addCase(staffAttendanceList.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.list = action.payload.data.data;
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.list = []
            }
        });

        builder.addCase(staffAttendanceCalendar.pending, (state) => {
            state.calendarLoading = true;
        });
        builder.addCase(staffAttendanceCalendar.fulfilled, (state, action) => {
            state.calendarLoading = false;
            if (action?.payload?.status === 200) {
                state.calendarData = action.payload.data.data;
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.calendarData = null
            }
        });
        builder.addCase(staffAttendanceCalendar.rejected, (state) => {
            state.calendarLoading = false;
            state.calendarData = null;
        });

        builder.addCase(staffAttendanceDetails.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.details = action.payload.data.data;
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.details = null
            }
        });
    }
})

export const { resetCalendarData } = staffAttendance.actions;
export default staffAttendance.reducer;